import i18n from '@/i18n';
import { TranslateResult } from 'vue-i18n';

// if you are considering on using the yesNoLoose your should consider
// to double negate the variable you pass in instead of using the yesNoLoose
export function yesNoLoose(value: unknown): TranslateResult {
  return i18n.t(value ? 'yes' : 'no');
}

export function yesNo(value: unknown): TranslateResult {
  if (value === true) return i18n.t('yes');
  if (value === false) return i18n.t('no');

  // eslint-disable-next-line no-console
  console.error(`yesNo filter received '${value}', which is not a boolean`);
  return i18n.t(`Message.somethingWentWrong`);
}
